<!-- eslint-disable  -->
<template>
  <div class="main-container">
    <div class="data_item" v-if="notes" v-for="(notes, index) in companyNotes" :key="notes.id" :class="{ first: index === 0 }">
      <div class="data_item_top">
        <div class="data_info">
          <a v-if="notes.creatUser" @click="clickPerson(notes.creatUser.id)" data-ga-id="首页-工作进展-点击跟进人">
            <a-avatar :src="notes.creatUser.avatar" class="avatar-bg gap-r-10">{{ notes.creatUser.nickname[0] }}</a-avatar>
          </a>
          <a-avatar :size="40" icon="user" class="data_avator" v-else />
          <a data-ga-id="首页-工作进展-点击跟进人" class="username avatar-height" v-if="notes.creatUser" @click="clickPerson(notes.creatUser.id)">
            <span class="label" style="margin-right: 5px; cursor: pointer">{{ notes.creatUser.nickname }}</span>
          </a>
          <span style="color: #999" class="avatar-height" v-if="!isDetail">|</span>
          <span
            class="label company-name avatar-height"
            style="margin: 0 16px 0 5px; color: #1890ff; cursor: pointer"
            v-if="notes.company && !isDetail"
            @click="clickDetail(notes.company.id)"
            data-ga-id="首页-工作进展-点击项目名"
            >{{ notes.company.name }}</span
          >
          <span
            style="margin-right: 16px"
            v-if="notes.execDate || notes.isEdit"
            class="followup-date avatar-height"
            :style="{ marginLeft: isDetail ? '16px' : '0px' }"
          >
            <span class="label">跟进日期：</span>
            <span v-show="!notes.isEdit" class="font14">{{ notes.execDate }}</span>
            <a-date-picker v-show="notes.isEdit" size="small" style="width: 120px; margin-right: 10px" v-model="execDate" format="YYYY-MM-DD" />
          </span>
          <span class="label avatar-height" v-if="notes.owners || notes.isEdit">内部参与人员：</span>
          <div style class="participants" v-if="notes.owners && notes.owners.length">
            <span style="margin-right: 6px" class="font14 pointer" v-show="notes.owners && !notes.isEdit" v-for="(user, ui) in notes.owners" :key="ui">
              <router-link :to="{ path: '/person', query: { id: user.id } }">{{ user.nickname }}</router-link>
            </span>
          </div>
          <select-member
            v-if="notes.isEdit"
            :width="100"
            :userlist="owners"
            :abridged="4"
            :parentIndex="index"
            @delChosenUser="delOwners"
            @chose="choseBackUserIds"
          ></select-member>
          <div class="info_tab" v-if="notes.isEdit">
            <span class="label avatar-height">消息通知：</span>
            <select-member
              :userlist="notifyUsers"
              :width="50"
              :parentIndex="index"
              :placement="'topCenter'"
              @delChosenUser="delNotifyUsers"
              @chose="choseBackUserIds2"
            ></select-member>
          </div>
        </div>
        <div class="data_time">
          <span>{{ notes.updateAt }}</span>
        </div>
        <!-- <div class="data_tag">
          <a-tag class="tag_item" v-for="(tag, ti) in notes.tags" :key="ti" color="blue">{{ tag.name }}</a-tag>
          <a-dropdown v-if="notes.isEdit" :trigger="['click']" v-model="visibleTag" placement="bottomRight" style="width: 30px">
            <a-button type="primary" size="small" style="margin-right: 10px">
              <a-icon type="right" />
            </a-button>
            <div slot="overlay">
              <project-tag :taglist="notesTagIds" v-if="visibleTag && index == tempedit" @change="taskTagChange"></project-tag>
            </div>
          </a-dropdown>
        </div> -->
      </div>
      <div class="data_item_ctn">
        <!-- <div class="data_time">
          <span>{{ notes.updateAt }}</span>
        </div> -->
        <div class="data_tag">
          <a-tag class="tag_item" v-for="(tag, ti) in notes.tags || []" :key="ti" color="blue">{{ tag.name }}</a-tag>
          <a-dropdown v-if="notes.isEdit" :trigger="['click']" v-model="visibleTag" placement="bottomRight" style="width: 30px">
            <a-button type="primary" size="small" style="margin-right: 10px">
              <a-icon type="right" />
            </a-button>
            <div slot="overlay">
              <project-tag :taglist="notesTagIds" v-if="visibleTag && index == tempedit" @change="taskTagChange"></project-tag>
            </div>
          </a-dropdown>
        </div>
        <div v-if="!notes.tags" class="blank_row"></div>
        <div class="data_file" v-if="notes.companyFiles">
          附件：
          <a v-for="(companyFile, index) in notes.companyFiles" :key="index" @click="viewCompany(companyFile)">
            {{ companyFile.name }}
            <span v-if="index + 1 < notes.companyFiles.length">,</span>
          </a>
        </div>
        <div class="description">
          <div
            v-show="!notes.isEdit"
            ref="introduce"
            class="introduce"
            :style="{ overflow: notes.isunfold ? 'hidden' : 'auto', height: notes.isShow && notes.isunfold ? '100px' : '' }"
            @click="click"
          >
            <div v-html="notes.content" @click="changeFold(notes)"></div>
            <div class="notified_person">
              <div v-if="notes.notifyUsers" style="display: flex">
                <div class="title">消息通知：</div>
                <div class="notified_item" v-for="(user, index) in notes.notifyUsers" :key="index">
                  <router-link :to="{ path: '/person', query: { id: user.id } }">{{ user.nickname }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div v-show="notes.isEdit" class="editor_box">
            <tinymce
              ref="tinymceEditor"
              :key="notes.id"
              :value="notes.content"
              :id="'editor' + notes.id"
              :members="projectMemberList"
              :uploadImgServer="editorConfig.uploadImgServer"
              :menus="editorConfig.menus"
            ></tinymce>
            <div class="action-btn">
              <div style="display: flex"></div>
              <div>
                <a type="text" class="cancel-text" @click="clickCancel(notes, index)">取消</a>
                <a-button type="primary" size="small" style="width: 100px" htmlType="submit" :loading="saveLoading" @click="saveInfo(notes, index)"
                  >保存</a-button
                >
              </div>
            </div>
          </div>
          <div class="unfold" v-if="notes.isShow">
            <a
              data-ga-id="首页-工作进展-点击展开"
              data-ga-value="down"
              style="margin-right: 10px; display: block"
              v-if="notes.isunfold"
              @click="notes.isunfold = false"
            >
              <!-- <a style="margin-right:10px;display:block" v-if="notes.isunfold" @click="notes.isunfold = false" > -->
              <a-icon type="down" />
            </a>
            <a data-ga-id="首页-工作进展-点击展开" data-ga-value="up" v-else @click="notes.isunfold = true">
              <a-icon type="up" />
            </a>
          </div>
          <div class="operate" v-if="!notes.isEdit && notes.workProgressType == 1">
            <div class="operate_container">
              <div class="operate_item" @click="clickEdit(notes, index)"><a-icon type="edit"></a-icon>编辑</div>
              <a-popconfirm title="确定删除吗?" @confirm="() => clickDelete(notes)">
                <div class="operate_item"><a-icon type="delete"></a-icon>删除</div>
              </a-popconfirm>
              <div class="operate_item" @click="clickComment(notes, index)">
                <a-icon type="message"></a-icon>评论
                <span v-if="notes.comments.total != 0">({{ notes.comments.total }})</span>
              </div>
            </div>
          </div>
          <div
            class="interact-container"
            :class="{ 'interact-container-bold': !notes.comments.list || notes.comments.list.length == 0 }"
            v-if="notes.interactArr && notes.interactArr.length > 0"
          >
            <div class="icon-item" v-for="item in notes.interactArr" :key="item.iconId" v-if="item['users'] && item['users'].length">
              <img class="icon-img" :src="interactIconsOutline[item['iconId']]" v-if="item['users'] && item['users'].length" />
              <div v-if="item['users'] && item['users'].length">{{ item['users'].join(',') }}</div>
            </div>
          </div>
          <div class="comment" v-show="notes.isComent">
            <div class="interact">
              <div class="icon-item" v-for="(item, index) in interactIcons" :key="index" @click="clickInteract(index, notes)">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ interactIconHint[index] }}</span>
                  </template>
                  <img class="icon-img" :src="item" />
                </a-tooltip>
              </div>
            </div>
            <!-- <at-ta
              v-model="comment"
              :members="projectMemberList"
              name-key="nickname"
              :filter-match="filterMatch"
              ref="at"
            >
              <a-textarea v-model="comment" :autoSize="{ minRows: 2, maxRows: 6 }" />
            </at-ta>-->
            <a-mentions v-model="comment">
              <a-mentions-option v-for="person in projectMemberList" :key="person.id" :value="person.nickname">
                {{ person.nickname }}
              </a-mentions-option>
            </a-mentions>

            <div class="operate" style="margin-top: 10px">
              <a-button size="small" style="width: 100px; margin-right: 10px" @click="notes.isComent = false">收起</a-button>
              <a-button type="primary" size="small" style="width: 100px" htmlType="submit" :loading="commentLoading" @click="addComment(notes, true)"
                >发送</a-button
              >
            </div>
          </div>

          <div class="comment" v-for="(item, child) in notes.comments.list" :key="child" v-if="notes.workProgressType == 1">
            <div class="comment_info">
              <div>
                <img :src="item.fromUser.avatar" class="comment_avator" alt :onerror="defaultImg" />
                <span class="text_blue">{{ item.fromUser.nickname }}</span>
                <span v-if="item.toUser">
                  &nbsp;&nbsp;回复&nbsp;&nbsp;
                  <span class="text_blue">{{ item.toUser.nickname }}</span
                  >:
                </span>
              </div>
              <span>{{ item.createAt }}</span>
            </div>
            <div class="comment_ctn">
              <div class="content">{{ item.content }}</div>
              <div class="del">
                <a @click="delComment(item.id, notes.id)" v-if="userInfo.id == item.fromUser.id">删除</a>
                <a @click="clickChildren(item, child)">回复</a>
              </div>
            </div>
            <div class="comment-interact-container">
              <div class="icon-item" v-for="item in item.interactArr" :key="item.iconId" v-if="item['users'] && item['users'].length">
                <img class="icon-img" :src="interactIconsOutline[item['iconId']]" v-if="item['users'] && item['users'].length" />
                <div v-if="item['users'] && item['users'].length">{{ item['users'].join(',') }}</div>
              </div>
            </div>
            <div class="comment" v-show="entityId === item.entityId && temp === child">
              <div class="comment-interact">
                <div class="icon-item" v-for="(icon, index) in interactIcons" :key="index" @click="clickCommentInteract(index, item)">
                  <img class="icon-img" :src="icon" />
                </div>
              </div>
              <!-- <at-ta
                v-model="comment"
                :members="projectMemberList"
                name-key="nickname"
                :filter-match="filterMatch"
                ref="at"
              >
                <a-textarea v-model="comment" :autoSize="{ minRows: 2, maxRows: 6 }" />
              </at-ta>-->
              <a-mentions v-model="comment">
                <a-mentions-option v-for="person in projectMemberList" :key="person.id" :value="person.nickname">
                  {{ person.nickname }}
                </a-mentions-option>
              </a-mentions>

              <div class="operate" style="margin-top: 10px">
                <a-button size="small" style="width: 100px; margin-right: 10px" @click="(entityId = ''), (temp = '')">收起</a-button>
                <a-button type="primary" size="small" style="width: 100px" htmlType="submit" :loading="commentLoading" @click="addComment(notes, false)"
                  >发送</a-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal :width="600" v-model="annexModal" @cancel="annexClose" title="附件上传" :footer="null">
      <document-upload
        ref="document"
        :annexId="annexId"
        :companyId="companyId"
        :typeId="fileTypeId"
        :file="fileName"
        @close="annexModal = false"
        @update="clickAnnex"
      ></document-upload>
    </a-modal>
    <a-modal v-model="visible" :footer="null" width="90%">
      <div class="img-container">
        <img :src="imgSrc" />
      </div>
    </a-modal>
  </div>
</template>

<script>
/* eslint-disable */
import AtTa from 'vue-at/dist/vue-at-textarea';
import moment from 'moment';
import { mapGetters } from 'vuex';
import tinymce from 'components/base/tinymce';
import { searchNickName, searchByName } from '@/api/common';
import projectTag from 'components/project/projectTag';
import documentUpload from '@/components/project/documentUpload';
import selectMember from '@/components/project/selectMember';
import { delComment, editCompanyNotes, deleteCompanyNotes, addComment } from '@/api/work';
import { interactRequest } from '@/api/project';
export default {
  components: {
    tinymce,
    projectTag,
    documentUpload,
    selectMember,
    AtTa
  },
  data() {
    return {
      interactIconsOutline: [
        `/interact/heart-outline.png`,
        `/interact/like-outline.png`,
        `/interact/plus-outline.png`,
        `/interact/comeon-outline.png`,
        `/interact/thanks-outline.png`,
        `/interact/OK-outline.png`,
        `/interact/submitted-outline.png`
      ],
      interactIconHint: [`点赞`, `Good Job`, `赞成`, `加油`, `感谢`, `收到`, `已提交`],
      interactIcons: [
        `/interact/heart.png`,
        `/interact/like.png`,
        `/interact/plus.png`,
        `/interact/comeon.png`,
        `/interact/thanks.png`,
        `/interact/OK.png`,
        `/interact/submitted.png`
      ],
      editorConfig: {
        uploadImgServer: '',
        menus: [
          'bold', // 粗体
          'italic', // 斜体
          'image', // 图片
          'link', // 链接
          '|',
          'fullscreen' // 全屏
          // 'head',	// 标题
          // 'fontSize',  // 字号
          // 'underline',  // 下划线
          // 'strikeThrough',  // 删除线
          // 'foreColor',  // 文字颜色
          // 'justify',	// 居中
          // 'list',	// 无序列表
          // 'quote',	// 引用
          // 'table',	// 表格
        ]
      },
      saveLoading: false,
      commentLoading: false,
      projectMemberList: [],
      execDate: moment(new Date(), 'YYYY-MM-DD'),
      currentUser: this.$store.state.user.userInfo,
      owners: [],
      notifyUsers: [],
      visibleTag: false,
      notesTagIds: [],
      comment: '',
      toUserId: '',
      entityId: '',
      temp: '',
      defaultImg: 'this.src="' + require('../../assets/image/defaultImg.png') + '"',
      backUserIds: [],
      backUserIds2: [],
      tempedit: '',
      annexId: '',
      fileTypeId: '',
      annexModal: false,
      companyId: '',
      fileName: '',
      visible: false,
      imgSrc: ''
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.getuserList();
    // this.pushNotify();
  },
  watch: {
    companyNotes() {
      this.$nextTick(function() {
        if (!this.$refs.introduce) return;
        let introduce = this.$refs.introduce;
        introduce.forEach((item, index) => {
          let height = item.offsetHeight;
          if (height >= 100) {
            this.companyNotes[index].isShow = true;
          }
        });
      });
    },
    comment() {}
  },
  props: ['companyNotes', 'loading', 'type', 'isDetail'],
  methods: {
    click(e) {
      let { target } = e;
      let { localName, currentSrc } = target;
      if (localName === 'img') {
        this.imgSrc = currentSrc;
        this.$nextTick(() => {
          this.visible = true;
        });
      }
    },
    handleInteract(index, interactArr, itemId, type) {
      let status = undefined;
      let operate = undefined;
      let users = undefined;
      let cursor = undefined;
      const position = interactArr.map(item => item.iconId).indexOf(index);
      if (position == -1) {
        //active
        status = 1;
        operate = 0;
      } else {
        users = interactArr[position]['users'];
        cursor = users.indexOf(this.currentUser.nickname);
        if (cursor != -1) {
          //inactive
          status = 0;
          operate = 2;
        } else {
          //active
          status = 1;
          operate = 1;
        }
      }
      let operation = [
        () => {
          interactArr.push({
            iconId: index,
            users: [this.currentUser.nickname]
          });
        },
        () => {
          users.push(this.currentUser.nickname);
        },
        () => {
          users.splice(cursor, 1);
        }
      ];
      if (type == 'reply') {
        type = 1;
      } else if (type == 'comment') {
        type = 0;
      }
      interactRequest({
        iconId: index,
        itemId,
        type: type,
        status: status
      }).then(res => {
        if (res.code == 200) {
          operation[operate]();
        }
      });
    },
    //给评论点赞
    clickCommentInteract(index, item) {
      const interactArr = item.interactArr;
      this.handleInteract(index, interactArr, item.id, 'reply');
    },
    //给companyNotes点赞
    clickInteract(index, note) {
      const interactArr = note.interactArr;
      this.handleInteract(index, interactArr, note.id, 'comment');
    },
    getuserList() {
      searchByName('').then(res => {
        if (res.code === 200) {
          this.projectMemberList = res.data.list;
        } else {
          this.projectMemberList = [];
        }
      });
    },
    filterMatch(name, chunk) {
      return name.toLowerCase().indexOf(chunk.toLowerCase()) > -1;
    },
    annexClose() {
      this.$refs.document.closeEdit();
    },
    clickAnnex(value) {
      this.annexId = value;
      this.annexModal = false;
    },
    viewCompany(row) {
      this.companyFileId = row.id;
      let type = row.fileSuffix;
      // pdf格式预览：docx,doc,odt,ott,sxw,rtf,wpd,html,txt, xlsx,xls,ods,ots,sxc,xls,xlsx,csv,tsv, pptx,ppt,odp,otp,sxi,pdf
      // image图像格式：jpg,jpeg,png,gif,bmp,ico,raw
      // video视频格式：avi,mov,rmvb,rm,flv,mp4,3gp
      const fileSuffix = [
        {
          type: 'pdf',
          strs: 'docx,doc,odt,ott,sxw,rtf,wpd,html,txt, xlsx,xls,ods,ots,sxc,xls,xlsx,csv,tsv, pptx,ppt,odp,otp,sxi,pdf'
        },
        { type: 'image', strs: 'jpg,jpeg,png,gif,bmp,ico,raw' },
        { type: 'video', strs: 'avi,mov,rmvb,rm,flv,mp4,3gp' }
      ];
      let temp = fileSuffix.filter(item => item.strs.indexOf(type) > -1);
      if (temp[0].type == 'video') {
        type = temp[0].type + '/' + type;
      } else {
        type = temp[0].type;
      }
      if (temp[0].type == 'pdf') {
        localStorage.setItem('download', row.canDownload);
        window.open(window.location.origin + '/pdfview?id=' + row.id);
      } else {
        window.open(window.location.origin + '/pdfview?id=' + row.id);
      }
    },
    clickDetail(code) {
      window.open(`${window.location.origin}/project/detail?id=${code}`);
    },
    clickPerson(id) {
      window.open(window.location.origin + '/person?id=' + id);
    },
    choseBackUserIds(value) {
      this.companyNotes[this.tempedit].owners = value;
      this.owners = value;
    },
    choseBackUserIds2(value, index) {
      this.companyNotes[index].notifyUsers = value;
      this.notifyUsers = value;
    },
    delNotifyUsers(user) {
      this.notifyUsers = this.notifyUsers.filter(_user => _user.id != user.id);
    },
    delOwners(user, index) {
      this.companyNotes[index].owners = this.owners.filter(_user => _user.id != user.id);
      this.owners = this.companyNotes[index].owners;
    },
    taskTagChange(tag) {
      this.companyNotes[this.tempedit].tags = tag;
      this.notesTagIds = tag;
      this.visibleTag = false;
    },
    formatOwners(notes) {
      if (!notes) return [];
      let arr = [];
      notes.forEach(item => {
        arr.push(item.id);
      });
      return arr;
    },
    clickComment(notes, index) {
      notes.isComent = true;
      this.comment = '';
      this.entityId = notes.id;
      this.toUserId = notes.creatUser.id;
    },
    clickDelete(notes) {
      deleteCompanyNotes(notes.id).then(res => {
        this.$emit('delete', notes.id);
      });
    },
    clickCancel(notes, index) {
      setTimeout(() => {
        notes.isEdit = false;
        let introduce = this.$refs.introduce[index];
        let offsetHeight = introduce.offsetHeight;
        if (offsetHeight >= 100) {
          this.companyNotes[index].isShow = true;
          this.companyNotes[index].isunfold = true;
        }
      }, 200);
    },
    clickChildren(item, index) {
      this.temp = index;
      this.entityId = item.entityId;
      this.toUserId = item.fromUser.id;
    },
    clickEdit(notes, index) {
      this.companyNotes[index].isShow = false;
      this.companyNotes[index].isunfold = false;
      this.$refs.tinymceEditor[index].initTinymce();
      if (notes.execDate) {
        this.execDate = moment(notes.execDate, 'YYYY-MM-DD');
      } else {
        this.execDate = moment(new Date(), 'YYYY-MM-DD');
      }
      this.owners = notes.owners || [];
      this.notifyUsers = notes.notifyUsers || [];
      this.notesTagIds = notes.tags || [];
      if (notes.companyFiles) {
        this.annexId = notes.companyFiles[0].id;
        this.fileTypeId = notes.companyFiles[0].fileTypeId;
        this.fileName = notes.companyFiles[0].name;
        this.companyId = notes.companyId;
      } else {
        this.annexId = '';
      }
      notes.isEdit = true;
      this.tempedit = index;
    },
    async addComment(notes, isComment) {
      this.commentLoading = true;
      const res = await addComment({
        entityId: this.entityId,
        content: this.comment,
        toUserId: this.toUserId,
        isComment
      });
      this.commentLoading = false;
      if (res.code === 200) {
        this.comment = '';
        if (notes.isEdit) {
          notes.isEdit = false;
        } else {
          this.entityId = '';
          this.temp = '';
        }
        this.$emit('update', notes.id);
      }
    },
    async saveInfo(notes, index) {
      let content = this.$refs.tinymceEditor[index].getContent();
      let notesTag = [];
      this.notesTagIds.forEach(item => {
        notesTag.push(item.id);
      });
      let ownerUserIds = [];
      this.owners.forEach(item => {
        ownerUserIds.push(item.id);
      });
      let notifyUserIds = [];
      this.notifyUsers.forEach(item => {
        notifyUserIds.push(item.id);
      });
      let body = {
        id: notes.id,
        companyId: notes.companyId,
        content,
        execDate: this.execDate.format('YYYY-MM-DD'),
        notesTagIds: notesTag.join(','),
        ownerUserIds: ownerUserIds.join(','),
        notifyUserIds: notifyUserIds.join(','),
        fileIds: this.annexId
      };
      this.saveLoading = true;
      const res = await editCompanyNotes(body);
      this.saveLoading = false;
      if (res.code === 200) {
        notes.isEdit = false;
        this.$emit('update', notes.id);
      }
    },
    delComment(id, pid) {
      delComment(id).then(res => {
        this.$emit('update', pid);
      });
    },
    changeFold(notes) {
      if (notes.isunfold) {
        notes.isunfold = !notes.isunfold;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.text_blue {
  color: #1890ff;
}
.font14 {
  font-size: 14px;
  color: #999;
}
.pointer {
  cursor: pointer;
}
.bottom_row {
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
  .info_tab {
    padding: 0 16px;
    display: flex;
  }
}
.data_item {
  border-bottom: 1px solid #f0f0f0;
  padding: 16px 0px 24px 0;
  .data_item_top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    // padding-top: 20px;
    .data_info {
      display: flex;
      // align-items: center;
      padding: 0 16px;
      .data_avator {
        margin: 0 16px 0 0;
        width: 32px;
        height: 32px;
        border-radius: 20px;
        margin-right: 16px;
        cursor: pointer;
      }
      .avatar-height {
        line-height: 32px;
      }
      .username {
        min-width: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .company-name {
        min-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .followup-date {
        min-width: 160px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .participants {
        max-width: 280px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        line-height: 20px;
        margin-top: 6px;
        // max-height: 20px;
      }
      .info_tab {
        padding: 0 16px;
        display: flex;
      }
    }
    // .data_tag {
    //   max-width: 220px;
    //   display: flex;
    //   flex-direction: column;
    //   justify-content:flex-end;
    //   .tag_item {
    //     margin-bottom: 4px;
    //     text-align: center;
    //   }
    // }
    .data_time {
      color: #999;
      padding-right: 16px;
      text-align: right;
    }
  }
  .data_item_ctn {
    // .data_time {
    //   color: #999;
    //   padding-right: 16px;
    //   text-align: right;
    // }
    .data_tag {
      // max-width: 220px;
      display: flex;
      padding-right: 16px;
      // flex-direction: column;
      justify-content: flex-end;
      .tag_item {
        margin: 0 0 0 8px;
        text-align: center;
      }
    }
    .blank_row {
      height: 21px;
    }
    .data_file {
      color: #999;
      padding-left: 16px;
    }
    .description {
      padding: 0 16px 0px 16px;
      line-height: 20px;
      font-size: 14px;
      .introduce {
        line-height: 20px;
      }
      .notified_person {
        display: flex;
        flex-wrap: wrap;
        max-width: 70%;
        padding-bottom: 10px;
        .title {
          font-weight: bold;
        }
        .notified_item {
          margin-right: 6px;
        }
      }
      .editor_box {
        .action-btn {
          border: 1px solid #ccc;
          border-top: none;
          height: 42px;
          padding: 0 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #000;
          cursor: pointer;
          .cancel-text {
            margin-right: 10px;
            color: rgba(0, 0, 0, 0.45);
            font-weight: 400;
            &:hover {
              color: #1890ff;
            }
          }
        }
      }
      .operate {
        display: flex;
        align-items: center;
        justify-content: space-between;
        justify-content: flex-end;
        margin-bottom: 8px;
        .operate_container {
          display: flex;
          justify-content: flex-end;
          .operate_item {
            display: flex;
            align-items: center;
            padding: 0 10px;
            border-right: 1px solid #ddd;
            cursor: pointer;
            transition: all 0.3s ease;
            i {
              margin: 0 6px 0 4px;
            }
            &:last-child {
              border-right: 0;
              padding-right: 0;
            }
            span {
              margin-right: 5px;
            }
            &:hover {
              color: @blue;
            }
          }
        }
      }
      .interact-container-bold {
        border-bottom: 0 !important;
        margin-bottom: 16px;
      }
      .interact-container {
        display: flex;
        flex-wrap: wrap;
        border-bottom: 1px solid rgb(239, 239, 239);
        background: rgba(249, 249, 249, 1);
        padding: 4px 20px;
        color: rgb(180, 180, 180);
        .icon-item {
          user-select: none;
          margin-right: 20px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          // mask
          img {
            margin-right: 8px;
            width: 15px;
            height: 15px;
          }
        }
      }
      .comment {
        background: rgba(249, 249, 249, 1);
        padding: 5px 16px;
        .interact {
          margin: 0px 0 4px 0;
          cursor: pointer;
          padding: 4px 0px;
          display: flex;
          flex-wrap: wrap;
          .icon-item {
            user-select: none;
            margin-right: 15px;
            width: 35px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            &:hover {
              background: rgba(255, 255, 255, 1);
            }
            // mask
            img {
              width: 80%;
              height: 80%;
            }
          }
        }
        &:last-child {
          margin-bottom: 16px;
        }
        .comment_info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .comment_avator {
            width: 30px;
            height: 30px;
            border-radius: 15px;
            vertical-align: middle;
            margin-right: 10px;
          }
        }
        .comment_ctn {
          display: flex;
          .content {
            padding-left: 40px;
            width: calc(100% - 100px);
          }
          .del {
            width: 100px;
            text-align: right;
            a:first-child {
              margin-right: 10px;
            }
          }
        }
        .comment-interact-container {
          display: flex;
          flex-wrap: wrap;
          margin: 4px 40px;
          background: rgba(240, 240, 240, 1);
          padding: 0 0 0 20px;
          width: fit-content;
          border-radius: 20px;
          color: rgb(180, 180, 180);
          .icon-item {
            user-select: none;
            margin-right: 20px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            // mask
            img {
              margin-right: 8px;
              width: 15px;
              height: 15px;
            }
          }
        }
        .atwho-wrap {
          padding: 0 20px;
        }
        .comment-interact {
          margin: -12px 0 4px 0;
          cursor: pointer;
          padding: 4px 20px;
          display: flex;
          flex-wrap: wrap;
          .icon-item {
            user-select: none;
            margin-right: 15px;
            width: 35px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            &:hover {
              background: rgba(255, 255, 255, 1);
            }
            // mask
            img {
              width: 80%;
              height: 80%;
            }
          }
        }
      }
    }
  }
}
.img-container {
  display: flex;
  justify-content: center;
}
.first {
  padding: 0 0 20px 0;
}
</style>

<style lang="less">
.introduce {
  ol,
  ul {
    margin-left: 28px;
    // list-style: square inside;
    li {
      display: list-item;
      text-align: -webkit-match-parent;
    }
  }
  ul {
    list-style-type: disc;
  }
  ol {
    list-style-type: decimal;
  }
}
.description img {
  max-height: 200px;
  width: auto;
}
.main-container {
  border: 1px solid #f0f0f0;
  padding: 20px 8px;
}
</style>
